import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { categoryActions } from "@/_actions/category.actions";

const Dependent = ({
  selectionHandler,
  category,
  subCategory,
  step,
  location,
}) => {
  const dispatch = useDispatch();
  const { categories, isLoading, error } = useSelector(state => state?.category);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [childCategory, setChildCategory] = useState([]);

  // useEffect(() => {
  //   dispatch(categoryActions.getCategories());
  // }, [dispatch]);

  useEffect(() => {
    if (category) {
      setSelectedCategory(category);
      const foundCategory = categories.find(
        (cat) => cat.categoryName === category
      );
      setChildCategory(foundCategory?.child_categories || []);
    }
  }, [category, categories]);

  const categoryChange = (event) => {
    const value = event.target.value;
    setSelectedCategory(value);
    const foundCategory = categories.find(
      (cat) => cat.categoryName === value
    );
    setChildCategory(foundCategory?.child_categories || []);
    selectionHandler(event.target, step);
  };

  return (
    <div className="category-container">
      <div className="category-item">
        <select
          aria-label="category"
          className="category"
          name="category"
          onChange={categoryChange}
          value={selectedCategory || ""}
        >
          <option value="">Select a Category</option>
          {categories &&
            categories.map((allCategory, index) => (
              <option key={index} value={allCategory.categoryName}>
                {allCategory.categoryName}
              </option>
            ))}
        </select>
      </div>
      {location !== "createBundle" && (
        <>
          {selectedCategory && childCategory.length > 0 && (
            <div className="category-item">
              <select
                name="subCategory"
                className="category"
                onChange={({ target }) => selectionHandler(target, step)}
                defaultValue={subCategory}
              >
                <option hidden>Select a Subcategory</option>
                {childCategory.map((allCategory, indx) => (
                  <option key={indx} value={allCategory.name}>
                    {allCategory.name}
                  </option>
                ))}
              </select>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Dependent;